import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import AOS from "aos";
import { jwtDecode } from "jwt-decode";
import { useDispatch, useSelector } from 'react-redux';
import { getHomeSevenSecData } from '../../../Redux/action/MasterAction';
import Aos from 'aos';

const host = process.env.REACT_APP_API_SERVER
const ConnectWithUs = () => {

    const [expanded, setExpanded] = useState({});
    const navigate = useNavigate();

    const handleNavigation = () => {
        const token = localStorage.getItem('student-token')
        if (token) {
            const decoded = jwtDecode(token);

            if (decoded?.user?.id) {
                navigate('/student/dashboard')
            }
            else {
                navigate('/login', { state: { user: 'student' } })
            }
        }
        else {
            navigate('/login', { state: { user: 'student' } })
        }

    }

    const toggleReadMore = (key) => {
        setExpanded(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    const dispatch = useDispatch();

    const {
        loadingHomeSevenSecDataApi,
        HomeSevenSecDataApiData,
        HomeSevenSecDataApiError,

    } = useSelector(state => state?.MasterReducer);

    useEffect(() => {
        dispatch(getHomeSevenSecData())

    }, []);

    useEffect(function () {
        Aos.init({ duration: 1000 });
    }, []);

    return (
        // <section className="responsive-section">
        //     <div className="responsive-container" data-aos="fade-up">
        //         <div className="content-wrapper">
        //             <div className="padding-standard">
        //                 <div className="inner-container">
        //                     <div className="grid-layout">
        //                         <div className="image-wrapper">
        //                             <div
        //                                 className="course-box"

        //                             >
        //                                 <div className="product">
        //                                     <div className="product-img">
        //                                         <a >
        //                                             <img
        //                                                 className="img-fluid"
        //                                                 alt=""
        //                                                 src={`${host}${HomeSevenSecDataApiData?.home_section_seven_main_image}`}
        //                                                 width={600}
        //                                                 height={300}
        //                                             />
        //                                         </a>
        //                                     </div>
        //                                     <div className="product-content">
        //                                         <h3 className="title">
        //                                             <a >{HomeSevenSecDataApiData?.home_section_seven_main_image_name}</a>
        //                                         </h3>
        //                                         <div className="author-info">
        //                                             <div className="author-name">{HomeSevenSecDataApiData?.home_section_seven_main_image_designation}</div>
        //                                         </div>
        //                                         <div className="rating">
        //                                             <i className="fas fa-star filled ms-1" />
        //                                             <i className="fas fa-star filled ms-1" />
        //                                             <i className="fas fa-star filled ms-1" />
        //                                             <i className="fas fa-star filled ms-1" />
        //                                             <i className="fas fa-star filled ms-1" />
        //                                             <span className="d-inline-block average-rating ms-1">
        //                                                 {HomeSevenSecDataApiData?.home_section_seven_main_image_rating}
        //                                             </span>
        //                                         </div>
        //                                         <div className="author-country">
        //                                             <p className="mb-0">
        //                                                 <i className="fe fe-map-pin" /> {HomeSevenSecDataApiData?.home_section_seven_main_image_location}
        //                                             </p>
        //                                         </div>
        //                                     </div>
        //                                 </div>
        //                             </div>
        //                         </div>
        //                         <div className="content-area">
        //                             <div className="content-title">
        //                                 <h2>{HomeSevenSecDataApiData?.home_section_seven_title}</h2>
        //                             </div>
        //                             <p className="text-large">
        //                                 {HomeSevenSecDataApiData?.home_section_seven_subtitle}
        //                             </p>
        //                             <div className="features-group">
        //                                 <div className="feature-item">
        //                                     <img
        //                                         src={`${host}${HomeSevenSecDataApiData?.home_section_seven_para_one_image}`}
        //                                         alt="Headphones Icon"
        //                                         className="feature-icons me-2"
        //                                     />
        //                                     <div className="feature-content">
        //                                         <h3>{HomeSevenSecDataApiData?.home_section_seven_para_one_title}</h3>
        //                                         <p>
        //                                             {HomeSevenSecDataApiData?.home_section_seven_para_one_subtitle}
        //                                         </p>
        //                                     </div>
        //                                 </div>
        //                                 <div className="feature-item">
        //                                     <img
        //                                         src={`${host}${HomeSevenSecDataApiData?.home_section_seven_para_two_image}`}
        //                                         alt="Signpost Icon"
        //                                         className="feature-icons me-2"
        //                                     />
        //                                     <div className="feature-content">
        //                                         <h3>{HomeSevenSecDataApiData?.home_section_seven_para_two_title}</h3>
        //                                         <p>
        //                                             {HomeSevenSecDataApiData?.home_section_seven_para_two_subtitle}
        //                                         </p>
        //                                     </div>
        //                                 </div>
        //                             </div>
        //                             <div className="cta-button">
        //                                 <a onClick={handleNavigation} className="btn btn-primary join">
        //                                     Connect With Us
        //                                 </a>
        //                             </div>
        //                         </div>
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </section>

        <section className="platform-section">
            <div className="platform-container" data-aos="fade-up">

                {/* LEFT CONTENT */}
                <div className="platform-left">

                    <h2>
                        {HomeSevenSecDataApiData?.home_section_seven_title}
                    </h2>

                    <p className="platform-subtitle">
                        {HomeSevenSecDataApiData?.home_section_seven_subtitle}
                    </p>

                    <div className="platform-features-tiles pb-3">

                        <div className="feature-tile">
                            <div className="feature-icon-tile">
                                <img
                                    src={`${host}${HomeSevenSecDataApiData?.home_section_seven_para_one_image}`}
                                    alt=""
                                />
                            </div>

                            <h4>
                                {HomeSevenSecDataApiData?.home_section_seven_para_one_title}
                            </h4>

                            <p>
                                {expanded[0]
                                    ? HomeSevenSecDataApiData?.home_section_seven_para_one_subtitle
                                    : HomeSevenSecDataApiData?.home_section_seven_para_one_subtitle?.slice(0, 80) + '...'}
                            </p>

                            {HomeSevenSecDataApiData?.home_section_seven_para_one_subtitle?.length > 80 && (
                                <span
                                    className="read-more-btn"
                                    onClick={() => toggleReadMore(0)}
                                >
                                    {expanded[0] ? 'Read Less' : 'Read More'}
                                </span>
                            )}
                        </div>


                        <div className="feature-tile">
                            <div className="feature-icon-tile">
                                <img
                                    src={`${host}${HomeSevenSecDataApiData?.home_section_seven_para_two_image}`}
                                    alt=""
                                />
                            </div>

                            <h4>
                                {HomeSevenSecDataApiData?.home_section_seven_para_two_title}
                            </h4>

                            <p>
                                {expanded[1]
                                    ? HomeSevenSecDataApiData?.home_section_seven_para_two_subtitle
                                    : HomeSevenSecDataApiData?.home_section_seven_para_two_subtitle?.slice(0, 80) + '...'}
                            </p>

                            {HomeSevenSecDataApiData?.home_section_seven_para_two_subtitle?.length > 80 && (
                                <span
                                    className="read-more-btn"
                                    onClick={() => toggleReadMore(1)}
                                >
                                    {expanded[1] ? 'Read Less' : 'Read More'}
                                </span>
                            )}
                        </div>

                    </div>

                    <button onClick={handleNavigation} className="mentor-btn ">
                        Connect With Us
                    </button>

                </div>

                {/* RIGHT IMAGE STACK */}
                <div className="platform-right">

                    {/* Main Image */}
                    <div className="main-image">
                        <img
                            src={`${host}${HomeSevenSecDataApiData?.home_section_seven_main_image}`}
                            alt=""
                        />
                    </div>

                    {/* Floating Info Card */}
                    <div className="profile-info-card">
                        <h4>
                            {HomeSevenSecDataApiData?.home_section_seven_main_image_name}
                        </h4>

                        <p className="designation">
                            {HomeSevenSecDataApiData?.home_section_seven_main_image_designation}
                        </p>

                        <div className="rating">
                            {[...Array(5)].map((_, i) => (
                                <i key={i} className="fas fa-star filled" />
                            ))}
                            <span className="rating-number">
                                {HomeSevenSecDataApiData?.home_section_seven_main_image_rating}
                            </span>
                        </div>

                        <p className="location">
                            <i className="fe fe-map-pin" />{" "}
                            {HomeSevenSecDataApiData?.home_section_seven_main_image_location}
                        </p>
                    </div>

                </div>

            </div>
        </section>
    )
}

export default ConnectWithUs